import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  createCompanyDepartment,
  getCompanyDepartments,
} from '@/shared/api/companies';
import { useAppQuery } from '@/shared/lib/useAppQuery';

const departmentsQueryKey = (companyId: string) =>
  ['company', companyId, 'departments'] as const;

export function useDepartments(companyId?: string) {
  return useAppQuery({
    queryKey: companyId ? departmentsQueryKey(companyId) : ['company', 'departments', 'disabled'],
    queryFn: () => getCompanyDepartments(companyId!),
    enabled: !!companyId,
    customError: true,
  });
}

export function useCreateDepartment(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { name: string }) => createCompanyDepartment(companyId, data),
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: departmentsQueryKey(companyId) });
    },
  });
}
